































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import DeepCopy from '@/decorators/deep-copy';
import { GQL_ProductVariantHolderCreate, GQL_ProductVariantCreate, GQL_ProductVariantUpdate, GQL_ProductVariantHolderUpdate } from '@/queries/global';
import { GQL_productVariantSearch_products } from '@/queries/__generated__/productVariantSearch';
import SPopup from '@/components/UI/Popup/SPopup.vue';
import gql from 'graphql-tag';

const PRODUCT_VARIANT_HOLDER_PRODUCT_SEARCH = gql`
  query productVariantSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: ProductFilter
  ) {
    products(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ){
      id
      number
      name
    },
  },
`;

@Component
export default class HolderForm extends Vue {
  @Prop({ required: true, type: Object }) private data!: GQL_ProductVariantHolderCreate | GQL_ProductVariantHolderUpdate;
  @DeepCopy('data') private formData!: GQL_ProductVariantHolderCreate | GQL_ProductVariantHolderUpdate;
  @Prop({ required: true, type: Function }) private formatDataForMutation!: Function;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) private query!: any;
  @Prop() private parentPopup!: SPopup


  private validForm = true;
  private showProductSelectTable = !(this.data as any).id; // eslint-disable-line @typescript-eslint/no-explicit-any
  private PRODUCT_VARIANT_HOLDER_PRODUCT_SEARCH = PRODUCT_VARIANT_HOLDER_PRODUCT_SEARCH;

  private rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductVariantHolder', 'name') }),
      },
    ],
     attributeName: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductVariantHolder', 'attributeName') }),
      },
    ],
    productVariants: {
      name: [
        {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductVariant', 'name') }),
        },
      ],
    },
  };

  @Emit()
  private mutationDone() {}

   public addProductAsVariant(product: GQL_productVariantSearch_products) {
    const newProductVariant = {
      id: undefined,
      name: '',
      productId: product.id,
      product: product,
    };

    this.formData.variants!.push(newProductVariant);
  }

  private removeVariant(variant: GQL_ProductVariantCreate | GQL_ProductVariantUpdate) {
     if ('id' in variant && variant.id) {
      Vue.set(variant, '_destroy', true);
    } else {
      const index = (this.formData.variants as (typeof variant)[]).indexOf(variant);
      this.formData.variants!.splice(index, 1);
    }
  }

   private get notDeletedVariants() {
    return (this.formData.variants as Array<{ _destroy?: boolean }>)
      .filter(variant => !variant._destroy);
  }
}
